import DemographicsComponent from './demographics.component';
import * as demographicsActions from './demographics.actions';
import { demographicsReducer, DemographicsState } from './demographics.reducer';

export {
  DemographicsComponent,
  demographicsActions,
  demographicsReducer,
  DemographicsState,
}



// WEBPACK FOOTER //
// src/demographics/index.js